import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'empty-with-toolbar-layout',
  templateUrl: './empty-with-toolbar.component.html',
  styleUrls: ['./empty-with-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmptyWithToolbarComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
